import Modal from "react-responsive-modal";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomButton from "components/CustomButton";
import CustomInput from "components/CustomInput/CustomInput";

const TodoNameModal = ({ handleModal, onSubmit }) => {
  const formik = useFormik({
    initialValues: {
      list_name: "",
    },
    validationSchema: Yup.object().shape({
      list_name: Yup.string()
        .min(4, "List name must be between 4 to 100 characters.")
        .max(100, "List name must be between 4 to 100 characters.")
        .trim()
        .required("Please enter the list name."),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values) => {
      onSubmit(values.list_name);
    },
  });
  return (
    <Modal
      open
      onClose={handleModal}
      showCloseIcon={false}
      classNames={{
        modalContainer: "modalContainer",
        modal: "queryModalContainer",
      }}
    >
      <div className="confirmationModalContent">
        <div className="chatGptQueryHeader">
          <h5 className="text-center confirmationModalHeader">
            To-do List Name
          </h5>
          <span className="chatgptCloseModal">
            <CancelIcon className="closeIcon" onClick={handleModal} />
          </span>
        </div>
        <hr />
        <div className="chatGptQueryContent mb-3">
          <form noValidate onSubmit={formik.handleSubmit}>
            <CustomInput
              id={"add-members"}
              formGroup={false}
              inputClass="full_w listInput"
              inputProps={{
                type: "text",
                placeholder: "List Name",
                ...formik.getFieldProps("list_name"),
                error: formik.errors.list_name,
              }}
            />
            <CustomButton buttonClass="btn grad_btn full_w" name={"Submit"} />
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default TodoNameModal;
